export const isPlatformBrowser = () => {
  if (typeof window !== 'undefined') {
    return true;
  } else {
    return false;
  }
};
